// @ts-nocheck
import {
  X,
  Share,
  Plus,
  DotsThree,
  List,
  Download,
  Check
} from '@phosphor-icons/react';
import { pwaInstallManager } from '../../services/pwaInstallManager';
import PropTypes from 'prop-types';
import './InstallModal.css';

/**
 * Install Instructions Modal
 * Shows platform-specific installation instructions
 */
const InstallModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const instructions = pwaInstallManager.getInstallInstructions();

  const getIcon = (iconName) => {
    const icons = {
      Share: <Share size={24} weight='regular' />,
      Plus: <Plus size={24} weight='regular' />,
      DotsThree: <DotsThree size={24} weight='regular' />,
      List: <List size={24} weight='regular' />,
      Download: <Download size={24} weight='regular' />,
      Check: <Check size={24} weight='regular' />
    };
    return icons[iconName] || <Plus size={24} weight='regular' />;
  };

  return (
    <div className='install-modal-overlay' onClick={onClose}>
      <div className='install-modal' onClick={(e) => e.stopPropagation()}>
        <div className='install-modal__header'>
          <h2 className='install-modal__title'>{instructions.title}</h2>
          <button
            className='install-modal__close-btn'
            onClick={onClose}
            aria-label='Close install instructions'
          >
            <X size={24} weight='regular' />
          </button>
        </div>

        <div className='install-modal__content'>
          {instructions.steps.map((step, index) => (
            <div key={index} className='install-modal__step'>
              <div className='install-modal__step-number'>{index + 1}</div>
              <div className='install-modal__step-icon'>
                {getIcon(step.icon)}
              </div>
              <p className='install-modal__step-text'>{step.text}</p>
            </div>
          ))}
        </div>

        <div className='install-modal__footer'>
          <p className='install-modal__help-text'>
            Once installed, you will be able to access your trip offline and
            return quickly from your home screen.
          </p>
          <button className='install-modal__got-it-btn' onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

InstallModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default InstallModal;
